import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, type RouteObject } from 'react-router-dom';
// The interface typeface, self-hosted with the bundle so no font request leaves the origin (decision 0317).
import '@fontsource-variable/inter';
import './styles/tokens.css';
import './styles/global.css';
import { baseRoutes } from './routes';
import { applyTextSize, rememberedTextSize } from './shell/textSize';
import { installChunkReload } from './shell/chunkReload';
import { MaintenanceGate } from './shell/MaintenancePage';

// 🔒 The person's text size draws before the first paint (decision 1321); the frame's own read confirms it once it answers.
applyTextSize(rememberedTextSize());
// 🔒 A chunk a deploy removed reloads the page once, guarded, before anything asks for one (decision 1460).
installChunkReload();

const routes: RouteObject[] = [...baseRoutes];
// The Component Test Page and every other developer route are stripped from the
// production build: when the constant is false the route below is dead code
// and its chunk is never emitted (piece 1). 🔒 Elsewhere they are one lazy route,
// loaded when first visited, so the first paint never waits for them.
if (__DEV_ROUTES__) {
  routes.push({
    path: '/dev/*',
    // Nothing is drawn while the chunk arrives on a first load that opens a developer route.
    HydrateFallback: () => null,
    lazy: async () => ({ Component: (await import('./dev/devRoutes')).DeveloperRoutes }),
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Index.html carries no #root element.');

createRoot(rootElement).render(
  <StrictMode>
    {/* 🔒 A recovery's maintenance replaces every route, the Login Screen's included (decision 4062). */}
    <MaintenanceGate apiBaseUrl={import.meta.env.VITE_API_BASE_URL ?? ''}>
      <RouterProvider router={createBrowserRouter(routes)} />
    </MaintenanceGate>
  </StrictMode>,
);
